import { connect } from 'react-redux';

import { getUpdatingSegment } from '../../../reducers/analyticsApp';
import { setSegmentName } from '../../../actions/segment';
import CompoundUpdateName from '../../../components/compound/update/Name';

const mapStateToProps = (state) => ({
  name: getUpdatingSegment(state).name,
});

const mapDispatchToProps = {
  onChange: setSegmentName,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompoundUpdateName);
